import { injectable } from 'tsyringe';
import { OwnerId } from '../../domain/owner/OwnerId';

@injectable()
export class OwnerIdFactory {
  tryMake(id?: string | null): OwnerId {
    return id ? new OwnerId(id) : OwnerId.empty;
  }
}
